import React from "react";
import { createMarkup } from "../../helpers";

const InputReadOnly = ({
  label,
  note = "",
  reqd,
  value,
  autocomplete = "off",
  placeholder = "",
}) => {
  return (
    <div>
      <label className="control-label">
        <span dangerouslySetInnerHTML={createMarkup(label)} />{" "}
        {reqd && <span className="reqd">*</span>}
      </label>
      <input
        type="text"
        value={value || ""}
        autoComplete="off"
        placeholder={placeholder}
        className="form-control"
        readOnly
      />
      <span className={note ? "note" : "hidden"}>{note}</span>
    </div>
  );
};

export default InputReadOnly;
